import { Row, Col } from "antd";
import Subtitle from "../../Subtitle";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";
import {
  Milestone,
  Car,
  Layers,
  ArrowLeftRight,
  ArrowUpDown,
  Wand,
  Lamp,
  Zap,
  Sun,
  Square,
} from "lucide-react";

export default function Nom013Section(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <>
      <Subtitle title="Información del exterior a verificar" marginTop={16} />
      <Row gutter={[16, 16]}>
        <Col {...responsiveInfo}>
          <DataGroup
            title={"Vialidad"}
            formName={"Vialidad"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Milestone size={16} />}
              iconColor="#1890ff"
              keyName="Tipo de Vialidad"
              value={verification?.TipoVialidad}
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Car size={16} />}
              iconColor="#82cc4b"
              keyName="Detalle de Vialidad"
              value={verification?.DetalleVialidad}
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Layers size={16} />}
              iconColor="#ffc53d"
              keyName="Tipo de Pavimento"
              value={verification?.TipoPavimento}
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ArrowLeftRight size={16} />}
              iconColor="purple"
              keyName="Ancho de Vialidad"
              value={verification?.AnchoVialidad}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<ArrowUpDown size={16} />}
              iconColor="brown"
              keyName="Largo de Vialidad"
              value={verification?.LargoVialidad}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Wand size={16} style={{ transform: "rotate(-45deg)" }} />}
              iconColor="orange"
              keyName="Distancia Interpostal"
              value={verification?.DistanciaInterpostal}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
        <Col {...responsiveInfo}>
          <DataGroup
            title={"Iluminación"}
            formName={"Iluminación"}
            mainData={verification}
            setMainData={setVerification}
            verification={verification}
          >
            <DataItem
              icon={<Lamp size={16} />}
              iconColor="#1890ff"
              keyName="Tipo de Lámpara"
              value={verification?.TipoLampara}
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Zap size={16} />}
              iconColor="#82cc4b"
              keyName="Potencia del Sistema"
              value={verification?.PotenciaSistema}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Sun size={16} />}
              iconColor="#ffc53d"
              keyName="Iluminancia Mínima"
              value={verification?.IluminanciaMinima}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
            <DataItem
              icon={<Square size={16} />}
              iconColor="purple"
              keyName="Superficie DPEA"
              value={verification?.SuperficieDPEA}
              valueType="number"
              fieldWidth={8}
              hidden={hidden}
              loading={loading}
            />
          </DataGroup>
        </Col>
      </Row>
    </>
  );
}
